
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"3","y":"5","width":"18","height":"12","rx":"2","stroke":"currentColor","stroke-width":"2"}}),_c('path',{attrs:{"d":"m9 17-3 3m9-3 3 3","stroke":"currentColor","stroke-linecap":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"m14.579 10.206c0.5613 0.3513 0.5613 1.2377 0 1.589l-3.329 2.0836c-0.557 0.3486-1.25-0.0919-1.25-0.7946v-4.167c0-0.70264 0.693-1.1431 1.25-0.79454l3.329 2.0836z","fill":"currentColor"}})])
          )
        }
      }
    